<template>
  <div class="page protocol">
    <navigation>综合授权书</navigation>
    <section class="content">
      <p class="text tab-2">授权人：●</p>
      <p class="text tab-2">证件号码：●</p>
      <p class="text tab-2">授权书生效日期：●</p>
      <p class="text tab-2">【特别提醒】：</p>
      <p class="text tab-2">
        <strong>为了保障您的合法权益，在您确认签署综合授权书之前，请您务必仔细阅读综合授权书的所有条款，充分理解条款内容，并严格遵守综合授权书。综合授权书以数据电文形式订立，一旦您在线确认综合授权书，即视为您已充分理解《综合授权书》所有条款的含义及相应的法律后果，并同意接受所有授权书条款的约束。</strong>
      </p>
      <p class="text tab-2">
        <strong>《综合授权书》是授权人向被授权人做出的单方承诺，效力具有独立性，不因《个人消费贷款合同》或其他文件任何条款的无效而无效。即使您的贷款申请未被审核通过，综合授权书各项授权的有效性不受影响。</strong>
      </p>
      <p class="text tab-2">【被授权人承诺】：</p>
      <p class="text tab-2">
        将严格遵照《征信业管理条例》等相关法律法规及监管规定，在客户授权范围内谨慎使用被授权信息并严格保密。可查询和使用信用数据期间，不应超过授权书授权期限结束之日。被授权人超出授权范围或期限查询的一切后果及法律责任由被授权人承担。
      </p>
      <p class="text tab-2">
        <strong>《综合授权书》由《个人信用报告查询专用授权书》和《个人信息采集及使用通用授权书》组成，《个人信用报告查询专用授权书》和《个人信息采集及使用通用授权书》可单独使用。</strong>
      </p>
      <p class="text tab-2" style="text-align: center;">
        <strong>个人信用报告查询专用授权书</strong>
      </p>
      <p class="text tab-2"><strong>一、授权内容</strong></p>
      <p class="text tab-2">
        授权人（亦称“本人”）同意向深圳市飞贷小额贷款有限公司和青海银行股份有限公司（以下简称“被授权人”）郑重授权如下：
      </p>
      <p class="text tab-2">
        1、同意被授权人根据国家有关规定，在办理下列业务时，通过中国人民银行个人信用信息基础数据库查询、打印、保存本人的信用报告,并授权给青海银行银行股份有限公司使用：
      </p>
      <p class="text tab-2">（1）审核本人的贷款申请；</p>
      <p class="text tab-2">（2）对已发放的个人信贷进行贷后风险管理；</p>
      <p class="text tab-2">（3）处理本人征信异议；</p>
      <p class="text tab-2">（4）依法或经有权部门要求向第三方提供；</p>
      <p class="text tab-2">（5）管理本人通过被授权人办理的其他业务；</p>
      <p class="text tab-2">（6）其他合法合规的用途。</p>
      <p class="text tab-2">
        2、同意被授权人将本人的基本信息和信用信息（含本人在被授权人处办理业务时产生的不良信息）报送中国人民银行个人信用信息基础数据库。
      </p>
      <p class="text tab-2">
        <strong>3、若本人在被授权人处办理的业务未获批准，本人同意被授权人继续保留本授权书和其他相关申请材料。</strong>
      </p>
      <p class="text tab-2"><strong>二、授权期限</strong></p>
      <p class="text tab-2">
        自本人作出本授权承诺之日起，至本人在被授权人处所有业务终结之日止。本人知悉并同意：本人在被授权人和/或其合作方处有贷款额度或授信但无贷款余额的情况下，<strong>本人与被授权人之间的业务关系仍然存续，被授权人仍有权向中国人民银行金融信用信息基础数据库查询、打印、保存或上报本人的基本信息和信用信息。</strong>
      </p>
      <p class="text tab-2"><strong>三、争议解决</strong></p>
      <p class="text tab-2">
        若本人与被授权人发生任何纠纷或争议，首先应友好协商解决。协商不成的，本人同意将纠纷或争议提交本授权书签订地（即青海省西宁市）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
      </p>
      <p class="text tab-2 margin-top-40" style="text-align: center;">
        <strong>个人信息采集及使用通用授权书</strong>
      </p>
      <p class="text tab-2 margin-top-40"><strong>一、定义</strong></p>
      <p class="text tab-2">1、个人信息，指您的如下信息：</p>
      <p class="text tab-2">
        （1）姓名、出生日期、身份证件号码、住址、电话号码、学历、声音、肖像、虹膜及其他类似的生物特征信息、工作信息、家庭信息等个人基本信息。
      </p>
      <p class="text tab-2">
        （2）借款申请信息、借款合同信息、还款行为信息、负债信息、借款逾期信息、欠缴水电煤等公用税费的信息、偿债履约能力判断信息、涉讼信息、行政处罚信息、违法犯罪信息等个人正常信用信息及不良信用信息。<strong>您已经充分理解并知晓：前述不良信用信息一旦记录在第三方机构的信息数据库中，有可能会对您日后的经济活动产生不同程度的不良影响。</strong>
      </p>
      <p class="text tab-2">
        （3）个人收入、存款、有价证券、商业保险、银行卡信息、不动产的信息和纳税数额信息等财产性信息。您已经认识的您的前述财产性信息对您而言是私密且重要的信息。<strong>您已经充分理解并知晓该等信息被提供和使用的风险。这些风险包括但不限于：纳入这些信息对您的信用评级（评分）、信用报告等结果可能产生不利影响，该等信息被被授权人依法提供给第三方后被他人不当利用的风险，因您的信用状况较好而造成您被第三方推销产品或服务等打扰的风险等。</strong>
      </p>
      <p class="text tab-2">
        （4）设备信息、社交数据、阅读数据、上网浏览/搜索数据、所用应用程序的账号信息、使用某项服务的时间地点等信息、联系人信息（含通讯录信息、通话记录信息以及您在申请服务过程中提交的联系人信息等）、消费数据（含近期交易笔数、交易金额及消费行为评分数据等）等个人行为特征数据信息。
      </p>
      <p class="text tab-2">
        （5）其他任何与您有关联的信息，但法律、法规、监管政策禁止的除外。
      </p>
      <p class="text tab-2">
        2、第三方，指与被授权人或您有直接或间接关联的如下主体或机构：
      </p>
      <p class="text tab-2">
        （1）中国人民银行个人信用信息基础数据库、中国互联网金融协会、依法设立的征信机构、资信评估机构或有关法律、监管机构许可的类似信用机构。
      </p>
      <p class="text tab-2">
        （2）被授权人关联方、为被授权人提供必要技术和服务的合作方，以及与被授权人合作从事信贷业务的金融机构或互联网金融公司。
      </p>
      <p class="text tab-2">
        （3）依法存有您某方面个人信息的其他机构，包括但不限于法院、公积金、社保、税务、民政、物流、通信运营商、电子商务平台、电子认证服务提供者、互联网平台等机构或主体。
      </p>
      <p class="text tab-2"><strong>二、授权内容</strong></p>
      <p class="text tab-2">
        本人现同意向【深圳市飞贷小额贷款有限公司和青海银行股份有限公司】（以下称“被授权人”）及第三方郑重授权如下：
      </p>
      <p class="text tab-2">
        1、同意被授权人及第三方在办理下列业务（下称“授权用途”）时查询、收集或使用本人的个人信息：
      </p>
      <p class="text tab-2">
        （1）审核本人通过被授权人或第三方申请的贷款；
      </p>
      <p class="text tab-2">
        （2）对已发放的个人信贷进行贷后风险管理及催收；
      </p>
      <p class="text tab-2">
        （3）出于电子签名方面的需要进行必要的身份注册及认证；
      </p>
      <p class="text tab-2">（4）处理本人征信异议；</p>
      <p class="text tab-2">（5）依法或经有权部门要求向第三方提供；</p>
      <p class="text tab-2">
        （6）管理本人通过被授权人或第三方办理的其他业务；
      </p>
      <p class="text tab-2">
        （7）为向本人提供更优的服务开展必要的市场调研或广告营销；
      </p>
      <p class="text tab-2">（8）其他合法合规的用途。</p>
      <p class="text tab-2">
        2、同意被授权人基于授权用途通过第三方查询、核实、采集本人的个人信息。<strong>为避免每次查询、核实或采集都需要经过本人的反复确认而导致过程繁琐、或者因此给本人带来不便，本人同意第三方可直接向被授权人提供本人的个人信息而不需要本人再次授权。但法律、法规、监管政策禁止的除外。</strong>
      </p>
      <p class="text tab-2">
        3、同意被授权人基于授权用途向第三方报送、提供、共享被授权人通过相关渠道获取的本人个人信息。
      </p>
      <p class="text tab-2">
        4、同意被授权人及第三方对依法获取的本人个人信息进行保存、分析、加工、整理或处理，包括但不限于将本人的个人信息纳入被授权人或第三方的风险模型并输出相应的信用评分/评级数据等。
      </p>
      <p class="text tab-2">
        5、同意第三方对依法获取的本人个人信息与合作机构进行使用、加工、评分。合作机构应对本人信息予以保密。
      </p>
      <p class="text tab-2">
        <strong>6、本人知悉并同意：《个人信用报告查询专用授权书》项下的被授权人有可能并非最终的贷款人，为提高贷款申请的成功率，被授权人有权在适当情形下（包括但不限于贷款申请被拒、被授权人产品形态或经营策略的调整等）将本人的贷款申请及个人信息转交至被授权人的其他合作方（包括但不限于相关的银行、消费金融公司、信托公司或小额贷款公司等），该种情形下被授权人及其前述新合作方有权直接使用《个人信用报告查询专用授权书》项下已查得的本人的个人征信信息，并有权将最终的借贷信息（含不良信息）上报中国人民银行个人信用信息基础数据库，被授权人及其新的合作方不需要本人再次授权。</strong>
      </p>
      <p class="text tab-2"><strong>三、授权期限</strong></p>
      <p class="text tab-2">
        自本人作出本授权承诺之日起，至本人在被授权人处所有业务终结之日止。<strong>本人知悉并同意：本人在被授权人和/或其合作方处有借款额度或授信但无借款余额的情况下，本人与被授权人的业务关系仍然存续，被授权人仍有权向第三方查询、打印、保存或上报本人的基本信息和信用信息。</strong>
      </p>
      <p class="text tab-2"><strong>四、争议解决</strong></p>
      <p class="text tab-2">
        若本人与被授权人发生任何纠纷或争议，首先应友好协商解决。协商不成的，本人同意将纠纷或争议提交本授权书签订地（即广东省深圳市）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'fd-comprehensive-authorization',

  mounted () {
    document.title = '综合授权书'
  },

  created () {
  },

  data () {
    return {
      // 签章信息
      sign: {}
    }
  }
}
</script>

